/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useMemo } from 'react';
import InviteTeamMemberForm from './InviteTeamMemberForm';
import { InviteTeamMemberProvider } from './InviteTeamMemberContext';
import { RootContext } from '../../hoc/RootContext/RootContext';
import { useLocation } from 'react-router-dom';

const InviteTeamMember = () => {
  const { currentUser } = useContext(RootContext);

  // Query Parameters
  const query = new URLSearchParams(useLocation().search);
  const queryCompany = query.get('company');
  const queryDisplayCompany = query.get('displayCompany');

  const [initCompany, initDisplayCompany] = useMemo(() => {
    let company = queryCompany;
    let displayCompany = queryDisplayCompany;
    if (currentUser) {
      company = currentUser.company
      displayCompany = currentUser.companyDisplayName;
    }
    if (currentUser && currentUser.companies.length > 1) {
      if (queryCompany) {
        company = queryCompany;
      }
      displayCompany = queryDisplayCompany;
    }
    return [company, displayCompany];
  }, [currentUser]);

  return (
    <InviteTeamMemberProvider>
      {initCompany && <InviteTeamMemberForm initCompany={initCompany} initDisplayCompany={initDisplayCompany} />}
    </InviteTeamMemberProvider>
  );
};

export default InviteTeamMember;
